import { client, gql } from 'data-provider';
import { ICategory } from 'interfaces';

interface getAllExpenseCategoryParams {
  searchString?: string;
}

export const getAllExpenseCategory = async (queryParam?: getAllExpenseCategoryParams) => {
  const where = { query: '' };
  if (queryParam?.searchString) {
    where.query = queryParam.searchString;
  }

  const query = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      expenseCategories(where: $where, sort: $sort, start: $start, limit: $limit) {
        data {
          id
          name
          description
          keywords
        }
      }
    }
  `;

  const variables = { where };
  const data = await client.request(query, variables);
  return data.expenseCategories as {
    data: ICategory[];
  };
};

export const getExpenseCategory = async (id: string) => {
  const query = gql`
    query ($expenseCategoryId: ID!) {
      expenseCategory(id: $expenseCategoryId) {
        id
        name
        description
      }
    }
  `;

  const variables = { expenseCategoryId: id };
  const data = await client.request(query, variables);
  return data.expenseCategory as ICategory;
};

export const createExpenseCategory = async (data: any) => {
  const query = gql`
    mutation ($input: createExpenseCategoryInput!) {
      createExpenseCategory(input: $input) {
        id
        keywords
        description
        name
      }
    }
  `;
  const variables = {
    input: { data },
  };

  const createdExpenseData = await client.request(query, variables);
  return createdExpenseData;
};

export const deleteExpenseCategory = async (id: string) => {
  const deleteExpenseCategory = gql`
    mutation ($input: deleteExpenseCategoryInput!) {
      deleteExpenseCategory(input: $input) {
        expenseCategory {
          id
        }
      }
    }
  `;
  const variables = {
    input: {
      where: { id },
    },
  };

  await client.request(deleteExpenseCategory, variables);
};

export const updateExpenseCategory = async (id: string, data: any) => {
  const updateExpenseCategory = gql`
    mutation ($input: updateExpenseCategoryInput) {
      updateExpenseCategory(input: $input) {
        id
        name
        description
        keywords
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
      data,
    },
  };
  const updatedData = await client.request(updateExpenseCategory, variables);
  return updatedData.updateExpenseCategory;
};
